import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const OutletCtx = createContext(null);
const LS_KEY = "teaboy_outlet_id";

export function OutletProvider({ children }) {
  const { authed } = useAuth();
  const [outlets, setOutlets] = useState([]);
  const [franchisees, setFranchisees] = useState([]);
  const [outlet, setOutletState] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authed) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [oRes, fRes] = await Promise.all([api.get("/outlets"), api.get("/franchisees")]);
      setOutlets(oRes.data);
      setFranchisees(fRes.data);
      const saved = localStorage.getItem(LS_KEY);
      const found = oRes.data.find((o) => o.id === saved) || oRes.data[0] || null;
      setOutletState(found);
      if (found) localStorage.setItem(LS_KEY, found.id);
    } finally {
      setLoading(false);
    }
  }, [authed]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const setOutlet = (o) => {
    setOutletState(o);
    if (o) localStorage.setItem(LS_KEY, o.id);
  };

  return (
    <OutletCtx.Provider value={{ outlet, outlets, franchisees, setOutlet, refresh, loading }}>
      {children}
    </OutletCtx.Provider>
  );
}

export const useOutlets = () => useContext(OutletCtx);
